module.exports = __webpack_public_path__ + "img/4.43ddc28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/academic/4.png
// module id = 589
// module chunks = 5